module.exports = __webpack_public_path__ + "img/P549205801.4cefb16e.jpg";